angular.module('home').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('/home/views/home.html',
    "<fpmain></fpmain>"
  );

}]);
